import { Box } from '@mui/material';

import { getReadinessTreatment } from '../theme/readinessTokens';
import type { BlockReadiness } from '../types/readiness';

interface Props {
  readiness: BlockReadiness;
  size?: number;
}

// Filled vs hollow is the load-bearing semantic across calendar dot, hover popover,
// and drawer hero chip.
//   filled = verdict reached AND no action pending
//   hollow = verdict reached BUT action pending, or info gap
export const ReadinessIndicator = ({ readiness, size = 10 }: Props) => {
  const treatment = getReadinessTreatment(readiness);
  if (!treatment) return null;

  const { color, filled } = treatment;

  return (
    <Box
      role="img"
      aria-label={`${readiness} readiness`}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        ...(filled
          ? { bgcolor: color }
          : { border: `2px solid ${color}`, bgcolor: 'transparent' }),
      }}
    />
  );
};
